/**
 * HelpShortcutsTab — keyboard shortcuts list (Day 60c).
 *
 * Two-column layout per COMPONENT_STANDARDS §4: keyboard key style left
 * (JetBrains Mono, surface-2 bg, border, rounded), action description right.
 *
 * Static list because useGlobalKeyboardShortcuts.ts only registers a window
 * keydown listener — it doesn't expose shortcut metadata. Today's wired
 * shortcuts: one (Shift+Ctrl+D, admin-only debug panel). When more land
 * (`/` global search, `?` help, command palette), add rows here.
 */
import type { JSX } from 'react';

interface ShortcutRow {
  /** Sequence of keys to chord. Each rendered as a separate <kbd>. */
  keys: ReadonlyArray<string>;
  /** Plain-language description of the action. */
  description: string;
  /** Optional gating note (admin-only, etc.). */
  note?: string;
}

const SHORTCUTS: ReadonlyArray<ShortcutRow> = [
  {
    keys: ['Shift', 'Ctrl', 'D'],
    description: 'Open Parallel Calculation Debug Panel',
    note: 'Admin only — silently inactive for non-admin users',
  },
];

export default function HelpShortcutsTab(): JSX.Element {
  return (
    <div className="px-4 py-3 space-y-3">
      <p className="text-2xs text-ink-muted leading-relaxed">
        Keyboard shortcuts wired across Arbi. More land in upcoming releases.
      </p>
      <ul className="space-y-2.5">
        {SHORTCUTS.map((s) => (
          <li key={s.keys.join('+')} className="flex items-start gap-3 text-xs">
            <div className="flex items-center gap-1 flex-shrink-0 pt-0.5">
              {s.keys.map((k, i) => (
                <span
                  key={i}
                  className="px-1.5 py-0.5 rounded border border-border bg-surface-2 text-2xs font-mono text-ink-bright"
                >
                  {k}
                </span>
              ))}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-ink-secondary leading-snug">{s.description}</div>
              {s.note && (
                <div className="text-2xs text-ink-muted mt-0.5 leading-snug">{s.note}</div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
